<template>
  <div class="relative bg-white rounded-lg border border-gray-200 p-4 text-center">
    <span
      v-if="variation != null"
      class="absolute top-2 right-2 text-xs font-bold px-1.5 py-0.5 rounded-full"
      :class="variationClass"
    >
      {{ variationLabel }}
    </span>
    <div class="text-2xl font-extrabold text-gray-900">
      <slot name="value">{{ value }}</slot>
    </div>
    <div class="text-xs text-gray-700 uppercase tracking-wide pt-1">{{ label }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [String, Number], default: null },
    label: { type: String, required: true },
    variation: { type: Number, default: null },
  },
  computed: {
    variationClass() {
      if (this.variation > 0) return "bg-green-100 text-green-700";
      if (this.variation < 0) return "bg-red-100 text-red-700";
      return "bg-gray-100 text-gray-500";
    },
    variationLabel() {
      if (this.variation > 0) return `+${this.variation}%`;
      return `${this.variation}%`;
    },
  },
};
</script>
